import { render, staticRenderFns } from "./ThreadDropdown.vue?vue&type=template&id=082f9fa8&scoped=true&"
import script from "./ThreadDropdown.vue?vue&type=script&lang=js&"
export * from "./ThreadDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ThreadDropdown.vue?vue&type=style&index=0&id=082f9fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f9fa8",
  null
  
)

export default component.exports